export default {
  newConference: 'Neue Konferenz',
  dialInNumber: 'Einwahlnummer',
  host: 'Host',
  participants: 'Teilnehmer',
  internationalParticipants: 'Internationale Teilnehmer',
  internationalNumbersHeader: 'Internationale Einwahlnummern auswählen',
  search: 'Suchen ...',
  inviteWithText: 'Mit Textnachricht einladen',
  inviteText: 'Nehmen Sie an der RingCentral-Konferenz teil. \n\nEinwahlnummern: {dialInNumber} \n\n{internationals} \nTeilnehmerzugang: {participantCode} \n\nBenötigen Sie eine internationale Einwahlnummer? Besuchen Sie http://www.ringcentral.com/conferencing \n\nDiese Telefonkonferenz wird über RingCentral-Konferenzen bereitgestellt.',
};
